export enum RewardCardStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED'
}

export enum RewardCardAccountStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export enum OperationsLogType {
  BLOCK = 'block_card',
  ORDER = 'order_card',
  TERMINATE = 'terminate_card',
  UNBLOCK = 'unblock_card'
}

export enum TransactionTypeCategory {
  CARD_FUNDING = 'CardFunding',
  SPEND = 'Spend'
}
